import { css } from 'styled-components';
import * as colors from '../../colors';
import * as cons from '../../constants';
export const DropDownWindow = css `
  border-radius: 8px;
  opacity: 1;
  padding: 4px 0px;
  box-shadow: ${cons.SHADOW_3};
  display: none;
  pointer-events: none;
  overflow: hidden;
  ${(props) => props.visible &&
    `
        display: block;
        pointer-events: auto;
    `}
`;
export const DropDownItem = css `
  color: ${colors.TINT_BLACK_2};
  display: flex;
  align-items: center;
  padding: 10px 16px;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background-color: ${colors.BLACK_9};
    /* background-color: ${colors.THEME_COLOR_9}; */
  }
  & img {
    opacity: 0.8;
    width: 14px;
    margin-right: 8px;
  }
`;
